<div class="progress-tiering-modes">
  @if (showMasterSlider) {
    <div class="tiering-mode-detail">
      <div class="tiering-mode-row">
        <h3>All</h3>
        <div class="tiering-mode-controls label-size-slider">
          <input type="range" min="0" max="4" [value]="masterIndex" (input)="onMasterSliderChange($event)" />
          <span class="label-size-value">{{ masterLabel }}</span>
          <button type="button" class="btn toggle-button toggle-buttom-equalizer equalizer-spacer" disabled tabindex="-1" aria-hidden="true">
            <span class="icon icon-equalizer"></span>
          </button>
        </div>
      </div>
      <div class="tiering-mode-divider" aria-hidden="true"></div>
    </div>
  }

  @for (domain of domains; track domain.key) {
    <div class="tiering-mode-detail">
      <div class="tiering-mode-row">
        <h3>{{ domain.label }}</h3>
        <div class="tiering-mode-controls label-size-slider">
          <input type="range" min="0" max="4" [value]="domain.index" (input)="onDomainSliderChange(domain, $event)" />
          <span class="label-size-value">{{ domain.modeLabel }}</span>
          @if (domain.isCustom) {
            <button type="button" class="btn toggle-button toggle-buttom-equalizer" title="Configure Custom Tiering Mode" (click)="openCustomDialog(domain)">
              <span class="icon icon-equalizer"></span>
            </button>
          } @else {
            <button type="button" class="btn toggle-button toggle-buttom-equalizer equalizer-spacer" disabled tabindex="-1" aria-hidden="true">
              <span class="icon icon-equalizer"></span>
            </button>
          }
        </div>
      </div>
      @if (domain.cutoffHint) {
        <div class="tiering-mode-hint">
          <app-tiering-cutoff-hint [hint]="domain.cutoffHint" [showArrow]="false" />
        </div>
      } @else {
        <div class="tiering-mode-hint tiering-mode-hint-spacer" aria-hidden="true"></div>
      }
    </div>
  }
</div>

@if (customDialogDomain === 'currency') {
  <app-custom-currency-tiering-mode-dialog [filter]="filter" (close)="closeCustomDialog()" />
}
@if (customDialogDomain === 'divCards') {
  <app-custom-div-card-tiering-mode-dialog [filter]="filter" (close)="closeCustomDialog()" />
}
@if (customDialogDomain === 'uniques') {
  <app-custom-uniques-tiering-mode-dialog [filter]="filter" (close)="closeCustomDialog()" />
}
@if (customDialogDomain === 'clusterJewel') {
  <app-custom-cluster-jewel-tiering-mode-dialog [filter]="filter" (close)="closeCustomDialog()" />
}
